import { useCallback, useRef, useState } from 'react'

// TODO: feels like low quality code, maybe check https://usehooks-ts.com/react-hook/use-intersection-observer will be better fit
interface UseIntersectionResult<T extends HTMLElement> {
  ref: (element: T | null) => void
  entry: IntersectionObserverEntry | null
}

export function useIntersection<T extends HTMLElement = HTMLElement>(
  options?: ConstructorParameters<typeof IntersectionObserver>[1],
): UseIntersectionResult<T> {
  const [entry, setEntry] = useState<IntersectionObserverEntry | null>(null)

  const observer = useRef<IntersectionObserver | null>(null)

  const ref = useCallback(
    (element: T | null) => {
      if (observer.current) {
        observer.current.disconnect()
        observer.current = null
      }

      if (element === null) {
        setEntry(null)
        return
      }

      observer.current = new IntersectionObserver(([_entry]) => {
        setEntry(_entry)
      }, options)

      observer.current.observe(element)
    },
    [options?.rootMargin, options?.root, options?.threshold],
  )

  return { ref, entry }
}
